import * as React from 'react';
import * as style from './ReviewItem.css';

export interface IReviewItemProps {
  id: string;
  author: React.ReactElement<any>;
  comment: React.ReactElement<any>;
  link: React.ReactElement<any> | false;
  reaction: React.ReactElement<any> | false;
}

export const ReviewItem: React.FC<IReviewItemProps> = ({ id, author, comment, link, reaction }) => {
  return (
    <div id={id} className={style['wrapper']}>
      <div className={style['header']}>{author}</div>
      <div className={style['content']}>{comment}</div>
      <div className={style['footer']}>
        {reaction}
        {link}
      </div>
    </div>
  );
};
